<template>
  <el-dialog
    v-if="!!docType"
    title="ПОРУЧЕНИЕ НА ПЕРЕВОЗКУ"
    class="instr-block"
    :append-to-body="true"
    :visible="visible"
    :width="isMobile ? '95%' : '50%'"
    @close="beforeClose"
  >
    <loader-wrapper :loading="loading">
      <el-row v-if="!docId" class="no-instr">
        НЕТ ПОРУЧЕНИЯ. Заполните форму и сохраните данные
      </el-row>
      <el-form
        ref="modalForm"
        :model="formData"
        :rules="rules"
        :label-position="isMobile ? 'top' : 'right'"
        label-width="120px"
        class="instr-body"
      >
        <el-container>
          <el-aside width="280px">
            <upload-img
              :img="files && files.length ? files[0].link : ''"
              @changed="handleFile"
              @delete="onDelete"
            />
          </el-aside>
          <el-container>
            <el-main style="max-width: 450px">
              <el-form-item prop="number" label="Поручение №:">
                <el-input
                  v-model="formData.number"
                  placeholder="Введите № поручения"
                />
              </el-form-item>
              <el-form-item prop="document_create_date" label="Дата:">
                <el-date-picker
                  v-model="formData.document_create_date"
                  type="date"
                  placeholder="Выберите дату"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-main>
            <el-footer height="auto">
              <el-button type="primary" :loading="loading" @click="onSaveBtn">
                Сохранить
              </el-button>
            </el-footer>
          </el-container>
        </el-container>
      </el-form>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { pickerOpt } from '@/datas/consts'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import UploadImg from '@/components/Upload/UploadImg'

const FilesApi = RepositoryFactory.get('file')
const ApiDoc = RepositoryFactory.get('doc')

export default {
  name: 'InstructionModal',
  components: { UploadImg, LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        number: '',
        document_create_date: '',
        file: '',
      },
      loading: false,
      docId: 0,
      files: '',
      rules: {
        number: { required: true, message: 'Заполните № АКТ', trigger: 'blur' },
        document_create_date: {
          required: true,
          message: 'Укажите дату',
          trigger: 'blur',
        },
      },
      pickerOptions: pickerOpt,
    }
  },
  computed: {
    docType() {
      return this.getDocumentByType('carrier_request')
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val && this.docType && this.visible) {
          this.getInstruction(val)
        }
      },
    },
  },
  methods: {
    getInstruction(id) {
      this.loading = true
      ApiDoc.getDocument('bids', id, this.docType.code)
        .then(res => {
          const { status, data } = res

          if (status === 200 && data && data[0]) {
            this.updateFields(data[0])
          } else {
            this.resetFields()
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.loading = false))
    },
    handleFile(file) {
      this.formData.file = file
    },
    onDelete() {
      if (this.files[0].id) {
        FilesApi.dellOne(this.files[0].id)
          .then(res => {
            if (res.status === 204) {
              this.$emit('update')
            }
          })
          .catch(e => this.errHandler(e))
      }
    },
    onSaveBtn() {
      this.$refs['modalForm'].validate(valid => {
        if (valid) {
          if (this.docId) {
            this.updateInstruction()
          } else {
            this.saveInstruction()
          }
        }
      })
    },
    saveInstruction() {
      this.loading = true
      const { file, ...fields } = this.formData

      ApiDoc.createDocument('bids', this.id, this.docType.id, fields)
        .then(res => {
          const { status, data } = res

          this.docId = data ? data.id : 0

          return file && this.docId && status === 201
            ? this.saveFile(file, this.docId)
            : ''
        })
        .then(() => {
          this.$message.success('Поручение успешно сохранено')
          this.$emit('update')
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.loading = false))
    },
    updateInstruction() {
      this.loading = true
      const { file, ...fields } = this.formData

      ApiDoc.update(this.docId, fields)
        .then(res => {
          const { status } = res

          if (status === 200) {
            if (this.files && this.files.length && this.files[0].id) {
              FilesApi.dellOne(this.files[0].id)
            }

            return file && this.docId ? this.saveFile(file, this.docId) : ''
          }
        })
        .then(() => {
          this.$message.success('Поручение успешно обновлено')
          this.$emit('update')
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.loading = false))
    },
    saveFile(file, id) {
      const formData = new FormData()

      formData.append('file_path', file)
      formData.append('document_id', id)

      return FilesApi.upload(formData, this)
    },
    beforeClose() {
      this.$emit('close', 'dialogInstruction')
    },
    updateFields(data) {
      const { id, number, document_create_date, files } = data

      this.docId = id
      this.formData.number = number
      this.formData.document_create_date = document_create_date
      this.files = files
    },
    resetFields() {
      this.docId = 0
      this.formData = {
        number: '',
        document_create_date: '',
        file: '',
      }
    },
  },
}
</script>

<style lang="sass">
.instr-block
  *
    font-family: 'Rubik', sans-serif
  .el-dialog__body, .el-dialog__title
    font-size: 18px
    color: #000000
  .el-input__inner
    height: auto
  .no-instr
    color: #FF0000
  .instr-body
    margin-top: 15px
    .el-button
      font-size: 15px
      margin-top: 40px
    .el-col-sm-18
      width: 75%
    .el-form-item__content
      line-height: 40px
    .el-form-item__label
      color: #000
    .el-input-number .el-input__inner
      text-align: left
    .el-input-number, .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: auto
    .el-footer
      text-align: right
</style>
